import { render, staticRenderFns } from "./areastaff.vue?vue&type=template&id=6050f125&scoped=true&"
import script from "./areastaff.vue?vue&type=script&lang=js&"
export * from "./areastaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6050f125",
  null
  
)

export default component.exports